import { useEffect, useRef, type TextareaHTMLAttributes } from 'react';

// Textarea that auto-grows to fit its content (no inner scrollbar). Starts at the
// given `rows` (default 3) and expands as the user types. Drop-in for <textarea>.
export function AutoTextarea(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const ref = useRef<HTMLTextAreaElement>(null);

  const resize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  };

  // Re-fit when the value changes (controlled inputs) and on mount.
  useEffect(resize, [props.value]);

  return (
    <textarea
      {...props}
      ref={ref}
      rows={props.rows ?? 3}
      onInput={(e) => { resize(); props.onInput?.(e); }}
      style={{ overflow: 'hidden', resize: 'none', ...props.style }}
    />
  );
}
